import { Component, Input, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-error-message',
  template: `
    <div [hidden]="!text" class="form-group row">
      <div class="col-12 alert alert-danger" [innerHTML]="text | safeHtml"></div>
    </div>
  `
})
export class ErrorMessageComponent implements OnInit {
  @Input()
  text: string;

  constructor(private log: LogService) {}

  ngOnInit() {}
}
